import axios from 'axios';

/**
 * V2 only: Removes a user's membership from the current division
 * without affecting their other divisions, Cognito, or sl-users.
 */
export default function RemoveMembershipFromDivision(userToRemoveEmail: string) {
  return axios.post(
    'api/user/RemoveMembershipFromDivision',
    {},
    {
      params: {
        userToBeRemovedEmail: userToRemoveEmail
      }
    }
  );
}
